import { render, staticRenderFns } from "./electronicbillZXCL.vue?vue&type=template&id=e80651a6"
import script from "./electronicbillZXCL.vue?vue&type=script&lang=js"
export * from "./electronicbillZXCL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports